// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6n-0";
export var startPickingButton = "_6n-1";